export const isSubMenuOpen = (currentPath, menuPath) =>
  currentPath.includes(menuPath) ? { defaultOpen: true } : {};
